import { useEffect } from 'react';
import { usePostHog } from 'posthog-js/react';
import { useLocation } from 'wouter';

export function useAnalytics() {
  const posthog = usePostHog();
  const [location] = useLocation();

  useEffect(() => {
    if (window.location.hostname.includes('localhost')) {
      posthog.opt_out_capturing();
      return;
    }
    function trackPageLoad() {
      posthog.capture('page_loaded', {
        load_time: performance.now(),
      });
    }
    window.addEventListener('load', trackPageLoad);
    return () => {
      window.removeEventListener('load', trackPageLoad);
    };
  }, [posthog]);

  useEffect(() => {
    posthog.capture('$pageview');
    return () => {
      posthog.capture('$pageleave');
    };
  }, [location, posthog]);
}
